/* @flow */
import React, { Component } from 'react';

import Button from 'components/Button.jsx';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import { pushRouterToChatWithMember } from 'lib/ChatRouteHelper';
import type { NamedInterlocutor } from 'lib/ChatRouteHelper';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { showRecent, hideRecent } from 'reducers/recentMessagesModal';

export class StartChatButton extends Component {
  props: {
    subscriber: NamedInterlocutor,
    useGlyph?: ?boolean,
    showRecent: Function,
    hideRecent: Function,
    onRequestHide?: ?Function,
    children?: any,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
    group: React.PropTypes.instanceOf(Group),
  };

  startChat = () => {
    const { group, router } = this.context;

    const subscriber: NamedInterlocutor = this.props.subscriber;

    pushRouterToChatWithMember(router, this.props.showRecent, this.props.hideRecent, subscriber, group);
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
  }

  render() {
    const {
      useGlyph,
      children,
      ...other
    } = this.props;
    if (children) {
      return (
        <div onClick={this.startChat}>
          {children}
        </div>
      );
    }
    if (useGlyph) {
      return (
        <Button
          {...other}
          size="xsmall"
          level="icon"
          tooltip="Send a message"
          tooltipPlacement="bottom"
          onClick={this.startChat}>
          <Glyph name="chat-add-bubble" size="xlarge" solo />
        </Button>
      );
    } else {
      return (
        <Button {...other} size="xsmall" onClick={this.startChat}>
          Send a message
        </Button>
      );
    }
  }
}

const mapDispatchToProps = (dispatch: Function) =>
  // $FlowIssue
  bindActionCreators({
    showRecent,
    hideRecent,
  }, dispatch);

export default connect(undefined, mapDispatchToProps)(StartChatButton);



// WEBPACK FOOTER //
// ./src/user/components/StartChatButton.jsx